





























































import {
  Vue,
  Component,
} from "@/shared/vuepack";
import {
  DrivewealthAccountSummary, DrivewealthAccountManagementType
} from "@/shared/types";
import { formatCurrency } from "@/shared/currency";
import _ from "lodash";
import moment from "moment";
import * as SharedRoutes from "@/shared/route-names";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { useDrivewealthStore } from "@/shared/store/drivewealth";

@Component({
  components: {
    GenericLoadingSpinner,
  }
})
export default class MultipleAccountSelection extends Vue {
  drivewealthStore = useDrivewealthStore();

  SharedRoutes = SharedRoutes;
  formatCurrency = formatCurrency;

  mounted (): void {
    this.drivewealthStore.loadAccountSummariesV2({force: true});
  }

  get formattedDateNow (): string {
    return moment().format("MMM DD");
  }

  get advisoryAccount (): DrivewealthAccountSummary {
    const account = _.find(this.drivewealthStore.accountSummariesV2,
      x => x.accountManagementType === DrivewealthAccountManagementType.Advisory);

    return account;
  }

  get hasAdvisoryAccount (): boolean {
    return this.advisoryAccount !== undefined;
  }

  get openBrokerageAccount (): DrivewealthAccountSummary {
    const account = _.find(this.drivewealthStore.accountSummariesV2,
      x => x.accountManagementType === DrivewealthAccountManagementType.OpenBrokerage);

    return account;
  }

  get hasOpenBrokerageAccount (): boolean {
    return this.openBrokerageAccount !== undefined;
  }

  get managedAccount (): DrivewealthAccountSummary {
    const account = _.find(this.drivewealthStore.accountSummariesV2,
      x => x.accountManagementType === DrivewealthAccountManagementType.RiaManaged);

    return account;
  }

  get hasManagedAccount (): boolean {
    return this.managedAccount !== undefined;
  }
}
